import * as React from "react";
import {
    Button,
    ButtonGroup,
    ButtonOr,
    Checkbox,
    Divider,
    Dropdown,
    Form,
    Icon,
    Input,
    Label,
    Popup,
    Segment,
    SemanticICONS
} from "semantic-ui-react";
import ReactTable from "react-table";
import {ConfigContext} from "../../../context/ConfigContext";
import {backend} from "../../../../../xconvert-backend";
import {authentication} from "../../../../../authentication";
import {ftp} from "../../../../../xconvert-ftp";
import {formatDate} from "../../../../../format";
import {FtpExplorerFileModal} from "./modals/FtpExplorerFileModal";
import {IfBox} from "../../../../style/if";
import {FtpExplorerFileDeleteModal} from "./modals/FtpExplorerFileDeleteModal";
import {FtpExplorerFileMoveModal} from "./modals/FtpExplorerFileMoveModal";
import {FileSystemEntry, ListFilesResponse, OpenFileRequest} from "../../../../../generated-ftp/api";
import Notifications, {notify} from 'react-notify-toast';
import {FtpExplorerAddFileModal} from "./modals/FtpExplorerAddFileModal";
import {FtpExplorerUploadFileModal} from "./modals/FtpExplorerUploadModal";
import {FtpExplorerMultipleFileMoveModal} from "./modals/FtpExplorerMultipleFileMoveModal";
import {FtpExplorerRenameFileModal} from "./modals/FtpExplorerRenameFileModal";
import {FtpExplorerMultiFileDeleteModal} from "./modals/FtpExplorerMultiFileDeleteModal";
import * as moment from "moment";
import {DateRangeStr} from "../../transportOrders/TransportOrderFilterComponent";
import {DateRange} from "../../transportOrders/DepotStockFilterComponent";
import {FaFileImport} from "react-icons/fa6";
import {FileWithState, uploadedFiles} from "../../../../util/FileUploadMultiple";
import {getNextWorkingDay} from "../../../../../utils";
import {CustomDateRangePicker} from "../../../../util/dateRangePicker/CustomDateRangePicker";
import {FtpExplorerMultiFileDownloadModal} from "./modals/FtpExplorerMultiFileDownloadModal";
import {FtpExplorerSignedDownloadFileModal} from "./modals/FtpExplorerSignedDownloadFileModal";
import {FtpExplorerConversionJobLogModal} from "./modals/FtpExplorerConversionJobLogModal";
import {ConversionJobLog} from "../../../../../generated/api";

const swaggerFtp = require("../../../../../../../swagger-ftp.json")


export interface FtpExplorerState {
    //essentials
    response: ListFilesResponse | null,
    isLoading: boolean,

    //Table
    take: number,
    page: number,
    pages: number,
    sortBy: 'DIRECTORY' | 'NAME' | 'SIZE' | 'CREATED' | 'MODIFIED',
    sortDirection: "ASC" | "DESC",

    //open
    openFile: boolean,
    //fileToOpen: null,
    fileToOpenBuffer: ArrayBuffer | null,
    fileToOpenName: string | null,

    //delete
    openFileDeleteView: boolean,
    openMultiFileDeleteView: boolean,
    fileToDelete: FileSystemEntry | null,

    //move
    openFileMoveView: boolean,
    fileToMove: FileSystemEntry | null,

    //add
    showAddFileModal: boolean,

    //upload
    showUploadFileModal: boolean,

    //download
    openFileDownloadModal: boolean,
    fileToDownload: ArrayBuffer | null,
    fileEntryToDownload: FileSystemEntry | null,
    deleteFileAfterwards: boolean

    //download multiple
    openFilesDownloadModal: boolean,
    openConversionJobLogModal: boolean,
    conversionJobLogLoading: boolean,
    conversionJobLogError: string | null,
    conversionJobLogs: ConversionJobLog[],
    selectedConversionJobLog: ConversionJobLog | null,
    conversionJobLogFilePath: string | null,

    selectedFiles: string[],
    showMoveMultipleFilesModal: boolean,

    renameFile: FileSystemEntry | null,
    showRenameModal: boolean,

    //search
    queryContent: boolean,

    ftpRegex: string

    // timeRangePicker
    fromDateTime?: Date
    toDateTime?: Date
    dateType: 'CREATED' | 'MODIFIED',
    dateRangeSelection?: DateRangeStr,
}

export class FtpExplorer extends React.Component
    <any, FtpExplorerState> {

    static contextType = ConfigContext
    context!: React.ContextType<typeof ConfigContext>;

    constructor(props) {
        super(props)
        console.log("loading FtpExplorer")

        this.state = {
            //essentials
            response: null,
            isLoading: true,

            //Table
            take: 25,
            page: 0,
            pages: -1,
            sortBy: "CREATED",
            sortDirection: "DESC",

            //open
            openFile: false,
            //fileToOpen: null,
            fileToOpenBuffer: null,
            fileToOpenName: null,

            //delete
            openFileDeleteView: false,
            openMultiFileDeleteView: false,
            fileToDelete: null,

            //move
            openFileMoveView: false,
            fileToMove: null,

            //add
            showAddFileModal: false,

            //upload
            showUploadFileModal: false,

            //download
            openFileDownloadModal: false,
            fileToDownload: null,
            fileEntryToDownload: null,
            deleteFileAfterwards: false,

            //download multiple
            openFilesDownloadModal: false,
            openConversionJobLogModal: false,
            conversionJobLogLoading: false,
            conversionJobLogError: null,
            conversionJobLogs: [],
            selectedConversionJobLog: null,
            conversionJobLogFilePath: null,

            selectedFiles: [],
            showMoveMultipleFilesModal: false,

            renameFile: null,
            showRenameModal: false,

            //search
            queryContent: false,
            ftpRegex: "",

            // timeRangePicker
            fromDateTime: undefined,
            toDateTime: undefined,
            dateType: 'CREATED',
            dateRangeSelection: "selection",
        }
    }

    async openDir(path: string = this.context.ftpPath, page: number = this.state.page) {
        this.setState({isLoading: true})

        let auth = backend.withTokenAuthHeader(authentication.token)
        let p = page
        if (p < 0) {
            p = 0
        }
        if (path == null) {
            path = "/"
        }
        let fromTime = this.state.fromDateTime
        let toTime = this.state.toDateTime
        let useModifiedTime = this.state.dateType == 'MODIFIED'

        let response = (await ftp.ftpApi.listFiles(
                this.context.companyId,
                fromTime,
                p,
                path,
                this.context.ftpRegex,
                this.state.queryContent,
                this.state.sortBy,
                this.state.sortDirection,
                this.state.take,
                toTime,
                useModifiedTime,
                auth
            )
        )

        console.log("setting path to : ", path)
        this.context.setFtpPath(path)
        this.setState({
            response: response,
            isLoading: false,
            selectedFiles: []
        }, () => {
            // to refresh the shown page in ReactTable, when changing the page from the outside (like after search, going to page 1)
            let div = document.getElementsByClassName("-pageJump")[0]
            let child = div?.childNodes[0] as HTMLInputElement
            child?.focus()
            child?.blur()
        })


    }

    buildPathForApi(path: string) {
        return "?path=" + path + "&companyId=" + this.context.companyId
    }

    async componentDidMount() {
        this.setState({ftpRegex: this.context.ftpRegex})
        this.openDir(this.context.ftpPath)
    }

    changePage(pageIndex: number) {
        this.setState({page: pageIndex})
        this.openDir(this.context.ftpPath, pageIndex)
    }

    changePageSize(newSize: number) {
        this.setState({take: newSize, page: 0, response: null}, () => {
            this.openDir(this.context.ftpPath, 0)
        })
    }

    changeSort(sortBy: 'DIRECTORY' | 'NAME' | 'SIZE' | 'CREATED' | 'MODIFIED' | 'NONE') {
        if (sortBy == 'NONE') {
            return
        }

        if (this.state.sortBy == sortBy) {
            let direction: "ASC" | "DESC" = this.state.sortDirection == "ASC" ? "DESC" : "ASC"
            this.setState({sortDirection: direction}, () => {
                this.openDir(this.context.ftpPath)
            })
        } else {
            this.setState({sortBy: sortBy, sortDirection: "ASC"}, () => {
                this.openDir(this.context.ftpPath)
            })
        }
    }

    beautifyPathView() {
        let path = this.context.ftpPath
        if (path.startsWith("//ROOT") || path.startsWith("/ROOT")) {
            return <Label as='a'>
                <Label.Detail>Customer
                    Folder: {path.substring(path.lastIndexOf("ROOT") + 4, path.length)}</Label.Detail>
            </Label>
        } else {
            return <Label as='a'>
                <Label.Detail>{this.context.ftpPath}</Label.Detail>
            </Label>

        }
    }

    selectAllFiles(files) {

        if (this.state.selectedFiles.length != files.length) {
            let allFileNames = files.map((file) => file.name)
            this.setState({selectedFiles: allFileNames})
        } else {
            this.setState({selectedFiles: []})
        }
    }

    moveSelectedFiles() {
        console.log(this.state.selectedFiles)
        this.setState({showMoveMultipleFilesModal: true})
    }

    resetFilters() {
        this.context.setFtpRegex(null)
        this.setState({
            ftpRegex: "",
            dateRangeSelection: "selection",
            fromDateTime: undefined,
            toDateTime: undefined,
            dateType: "CREATED"
        })
        this.openDir()
    }

    onDatesSelected = (startDate?: moment.Moment, endDate?: moment.Moment) => {
        this.setState({
                fromDateTime: startDate?.toDate(),
                toDateTime: endDate?.toDate(),
                dateRangeSelection: "selection"
            }
        )
    }

    onPredefinedDateRangeSelect = (evt: any, data: any) => {
        const dateRange: DateRange = this.calculateDateRange(data.value)

        this.setState({
            fromDateTime: dateRange.start,
            toDateTime: dateRange.end,
            dateRangeSelection: dateRange.selectorString as DateRangeStr,
        })
    }

    calculateDateRange(dateRangeStr?: string): DateRange {
        let dateRange = {} as DateRange

        switch (dateRangeStr) {
            case "selection":
                if (this.state.fromDateTime)
                    dateRange.start = this.state.fromDateTime
                if (this.state.toDateTime)
                    dateRange.end = this.state.toDateTime
                dateRange.selectorString = "selection"
                return dateRange
            case "nextWorkingDay":
                dateRange.start = getNextWorkingDay().startOf("day").toDate()
                dateRange.end = getNextWorkingDay().endOf("day").toDate()
                dateRange.selectorString = "nextWorkingDay"
                break;
            case "tomorrow":
                dateRange.start = moment().add(1, "days").startOf("day").toDate()
                dateRange.end = moment().add(1, "days").endOf("day").toDate()
                dateRange.selectorString = "tomorrow"
                break;
            case "today":
                dateRange.start = moment().startOf("day").toDate()
                dateRange.end = moment().endOf("day").toDate()
                dateRange.selectorString = "today"
                break;
            case "lastWorkingDay":
                dateRange.start = this.getLastWorkingDay().startOf("day").toDate()
                dateRange.end = this.getLastWorkingDay().endOf("day").toDate()
                dateRange.selectorString = "lastWorkingDay"
                break;
            case "yesterday":
                dateRange.start = moment().subtract(1, "days").startOf("day").toDate()
                dateRange.end = moment().subtract(1, "days").endOf("day").toDate()
                dateRange.selectorString = "yesterday"
                break;
            case "nextWeek":
                dateRange.start = moment().add(1, "weeks").startOf("week").toDate()
                dateRange.end = moment().add(1, "weeks").endOf("week").toDate()
                dateRange.selectorString = "nextWeek"
                break;
            case "thisWeek":
                dateRange.start = moment().subtract(0).startOf("week").toDate()
                dateRange.end = moment().subtract(0).endOf("week").toDate()
                dateRange.selectorString = "thisWeek"
                break;
            case "lastWeek":
                dateRange.start = moment().subtract(1, "weeks").startOf("week").toDate()
                dateRange.end = moment().subtract(1, "weeks").endOf("week").toDate()
                dateRange.selectorString = "lastWeek"
                break;
            case "thisMonth":
                dateRange.start = moment().subtract(0).startOf("month").toDate()
                dateRange.end = moment().subtract(0).endOf("month").toDate()
                dateRange.selectorString = "thisMonth"
                break;
            case "lastMonth":
                dateRange.start = moment().subtract(1, "months").startOf("month").toDate()
                dateRange.end = moment().subtract(1, "months").endOf("month").toDate()
                dateRange.selectorString = "lastMonth"
                break;
            case "last7days":
                dateRange.start = moment().subtract(6, "days").startOf("day").toDate()
                dateRange.end = moment().endOf("day").toDate()
                dateRange.selectorString = "last7days"
                break;
            case "last30days":
                dateRange.start = moment().subtract(29, "days").startOf("day").toDate()
                dateRange.end = moment().endOf("day").toDate()
                dateRange.selectorString = "last30days"
                break;
            case "plusMinus7Days":
                dateRange.start = moment().subtract(7, "days").startOf("day").toDate()
                dateRange.end = moment().subtract(-7, "days").endOf("day").toDate()
                dateRange.selectorString = "plusMinus7Days"
                break;
            default:
                dateRange.start = undefined
                dateRange.end = undefined

                return dateRange
        }

        return dateRange
    }

    renderDateRangePickerField() {
        const options = [
            {
                key: 'selection',
                text: 'Selection',
                value: 'selection'
            },
            {
                key: 'nextWorkingDay',
                text: 'NextWorkingDay',
                value: 'nextWorkingDay'
            },
            {
                key: 'tomorrow',
                text: 'Tomorrow',
                value: 'tomorrow'
            },
            {
                key: 'today',
                text: 'Today',
                value: 'today'
            },
            {
                key: 'lastWorkingDay',
                text: 'LastWorkingDay',
                value: 'lastWorkingDay'
            },
            {
                key: 'yesterday',
                text: 'Yesterday',
                value: 'yesterday'
            },
            {
                key: 'nextWeek',
                text: 'NextWeek',
                value: 'nextWeek'
            },
            {
                key: 'thisWeek',
                text: 'ThisWeek',
                value: 'thisWeek'
            },
            {
                key: 'lastWeek',
                text: 'LastWeek',
                value: 'lastWeek'
            },
            {
                key: 'thisMonth',
                text: 'ThisMonth',
                value: 'thisMonth'
            },
            {
                key: 'lastMonth',
                text: 'LastMonth',
                value: 'lastMonth'
            },
            {
                key: 'last7days',
                text: 'Last7Days',
                value: 'last7days'
            },
            {
                key: 'last30days',
                text: 'Last30Days',
                value: 'last30days'
            },
            {key: 'all', text: 'All', value: 'all'}
        ]
        const options2 = [
            {
                key: 'created',
                text: 'Created',
                value: 'CREATED'
            },
            {
                key: 'updated',
                text: 'Updated',
                value: 'MODIFIED'
            }
        ]
        let fromDate = this.state.fromDateTime ? moment(this.state.fromDateTime) : undefined;
        let toDate = this.state.toDateTime ? moment(this.state.toDateTime) : undefined;
        return <Form.Field>
            <div className="ui basic buttons">
                <Dropdown
                    selectOnBlur={false}
                    className="ui left"
                    basic button floating
                    value={this.state.dateType}
                    options={options2}
                    onChange={(evt: any, data: any) => {
                        this.setState({dateType: data.value})
                    }}
                />
                <div
                    className={"ui basic button"}
                    style={{padding: '0px'}}
                >
                    <CustomDateRangePicker
                        id={"FtpExplorerFilter"}
                        startDate={fromDate}
                        endDate={toDate}
                        onDatesSelected={this.onDatesSelected}
                    />
                </div>
                <Dropdown
                    selectOnBlur={false}
                    className="ui" basic button floating
                    value={this.state.dateRangeSelection}
                    options={options}
                    onChange={this.onPredefinedDateRangeSelect}
                />
                <Button icon
                        onClick={() => {
                            this.changePage(1)

                        }}><Icon name='search'/></Button>
                <br/>
            </div>
        </Form.Field>
    }

    getLastWorkingDay() {
        let workDay = moment().subtract(1, "days")
        if (workDay.day() === 0) workDay.subtract(2, "days")
        else if (workDay.day() == 6) workDay.subtract(1, "days")

        return workDay
    }

    iconButton(icon: SemanticICONS, disabled: boolean = false, func: () => void) {
        return <Button
            icon
            disabled={disabled}
            onClick={func}
        >
            <Icon name={icon}/>
        </Button>
    }

    isHome() {
        return this.context.ftpPath == "/"
    }

    renderButtons() {
        return <>
            <ButtonGroup>
                {this.iconButton('reply', this.isHome(), () => this.goUpADir())}
                {this.iconButton('refresh', false, () => this.openDir(this.context.ftpPath))}
                {this.iconButton('plus', this.isHome(), () => this.setState({showAddFileModal: true}))}
                {this.iconButton('upload', this.isHome(), () => this.setState({showUploadFileModal: true}))}
                {this.iconButton('download', this.state.selectedFiles.length == 0, () => this.setState({openFilesDownloadModal: true}))}
                {this.iconButton('move', this.context.ftpPath == "/" || this.state.selectedFiles.length == 0, () => this.moveSelectedFiles())}
                {this.iconButton('trash', this.state.selectedFiles.length == 0, () => this.setState({openMultiFileDeleteView: true}))}
                <Popup content={"open in importSim"} trigger={
                    <Button
                        icon
                        style={{height: 36}}
                        disabled={this.state.selectedFiles.length == 0}
                        onClick={() => this.openInImportSim(null)}>
                        <FaFileImport/>
                    </Button>
                }/>
            </ButtonGroup>
            <Input style={{width: 220}} placeholder='term'
                   value={this.state.ftpRegex}
                   onChange={(evt) => {
                       this.setState({ftpRegex: evt.target.value})
                       this.context.setFtpRegex(evt.target.value)
                   }}
            />
            <ButtonGroup>
                <Button icon disabled={
                    this.context.ftpRegex == null
                }
                        onClick={() => {
                            this.changePage(1)

                        }}><Icon name='search'/></Button>
                <Button
                    onClick={() => this.setState({queryContent: false})}
                    positive={!this.state.queryContent}
                >search for name</Button>
                <ButtonOr/>
                <Button
                    onClick={() => this.setState({queryContent: true})}
                    positive={this.state.queryContent}
                >search for content</Button>
            </ButtonGroup>
        </>

    }

    render() {

        console.log("RENDER FTP-EXPLORER")
        if (this.state.response) {
            let files: FileSystemEntry[] = this.state.response.files
            let filesWithoutDirs = files.filter((file) => !file.isDirectory)
            try {

                return <Segment className={"flex3"}>
                    <div>

                        {this.beautifyPathView()}
                        <Divider hidden/>

                        {this.renderButtons()}

                        <br/>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                            }}
                        >
                            {this.renderDateRangePickerField()}

                            <Button
                                disabled={
                                    this.context.ftpRegex == null &&
                                    this.state.fromDateTime == undefined &&
                                    this.state.toDateTime == undefined
                                }
                                onClick={() => this.resetFilters()}
                            >
                                Reset
                            </Button>
                        </div>
                        <br/>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                            }}>

                            <Checkbox
                                readOnly={filesWithoutDirs.length == 0}
                                checked={this.state.selectedFiles.length == filesWithoutDirs.length && filesWithoutDirs.length > 0}
                                onChange={() => this.selectAllFiles(filesWithoutDirs)}
                                label={"select all (" + filesWithoutDirs.length + " files)"}
                            />
                            <span>total number of files in this folder is: {this.state.response.totalFiles}</span>
                        </div>
                    </div>

                    {this.renderTable(files)}
                    {this.renderModals()}
                    <Notifications/>

                </Segment>
            } catch (ex) {
                console.error("Error: ", ex)
                return <Label color='red'>The data is in bad format: {JSON.stringify(files, null, 4)}</Label>
            }
        } else {
            return <Label color='yellow'>Loading...</Label>
        }


    }

    switchSelectionStateOfItem(name: string) {
        this.setState({isLoading: true})

        var array = [...this.state.selectedFiles]; // make a separate copy of the array
        var index = array.indexOf(name)
        if (index == -1) {
            // name not found, adding Id

            this.setState({selectedFiles: array.concat(name)})
            console.log("name added")


        } else {
            // name found, removing it

            array.splice(index, 1);
            this.setState({selectedFiles: array})
            console.log("name removed")

        }
        this.setState({isLoading: false})
    }

    generateLink(fileName: string) {
        let baseLink = swaggerFtp.info.contact.url + "/ftp/files/"
        let path = this.context.ftpPath.split("\/").join("%2F")
        return baseLink + fileName + "?path=" + path
    }

    openFileInNewTab(fileEntry: FileSystemEntry) {
        let link = this.generateLink(fileEntry.name)
        const newWindow = window.open(link, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    buildArchiveFilePath(fileName: string) {
        const normalizedPath = this.context.ftpPath.endsWith("/")
            ? this.context.ftpPath.slice(0, -1)
            : this.context.ftpPath;
        const withLeadingSlash = `${normalizedPath}/${fileName}`;
        return withLeadingSlash.startsWith("/") ? withLeadingSlash.substring(1) : withLeadingSlash;
    }

    parseCreatedTime(log: ConversionJobLog): number {
        if (!log.created) {
            return 0;
        }
        return new Date(log.created).getTime();
    }

    normalizeArchiveFilePath(path?: string): string {
        if (!path) {
            return "";
        }
        return path.startsWith("/") ? path.substring(1) : path;
    }

    sortLogsByCreatedDesc(entries: ConversionJobLog[]): ConversionJobLog[] {
        return [...entries].sort((a, b) => this.parseCreatedTime(b) - this.parseCreatedTime(a));
    }

    findMatchingConversionLogs(entries: ConversionJobLog[], archiveFilePath: string, fileName: string): ConversionJobLog[] {
        if (!entries || entries.length === 0) {
            return [];
        }

        const normalizedArchivePath = this.normalizeArchiveFilePath(archiveFilePath);
        const exactPathMatches = entries.filter(entry =>
            this.normalizeArchiveFilePath(entry.archiveFileName) === normalizedArchivePath
        );
        if (exactPathMatches.length > 0) {
            return this.sortLogsByCreatedDesc(exactPathMatches);
        }

        const fileNameMatches = entries.filter(entry => {
            const archiveName = this.normalizeArchiveFilePath(entry.archiveFileName).split("/").pop();
            return archiveName === fileName || entry.inputFileName === fileName;
        }
        );
        if (fileNameMatches.length > 0) {
            return this.sortLogsByCreatedDesc(fileNameMatches);
        }

        return this.sortLogsByCreatedDesc(entries);
    }

    mergeUniqueLogs(entriesA: ConversionJobLog[], entriesB: ConversionJobLog[]): ConversionJobLog[] {
        const byKey = new Map<string, ConversionJobLog>();
        const all = [...entriesA, ...entriesB];
        all.forEach(entry => {
            const fallbackKey = [
                this.normalizeArchiveFilePath(entry.archiveFileName),
                entry.inputFileName || "",
                entry.created || "",
                entry.result || "",
            ].join("|");
            const key = entry._id || fallbackKey;
            byKey.set(key, entry);
        });
        return Array.from(byKey.values());
    }

    async openConversionJobLog(fileEntry: FileSystemEntry) {
        const archiveFilePath = this.buildArchiveFilePath(fileEntry.name);
        this.setState({
            openConversionJobLogModal: true,
            conversionJobLogLoading: true,
            conversionJobLogError: null,
            conversionJobLogs: [],
            selectedConversionJobLog: null,
            conversionJobLogFilePath: archiveFilePath,
        });

        try {
            const auth = backend.withTokenAuthHeader(authentication.token);
            const companyId = this.context.companyId;

            const byFileName = await backend.internalApi.fetchConversionJobLogs(
                companyId,
                50,
                undefined,
                fileEntry.name,
                0,
                "CREATED",
                "DESC",
                auth
            );

            const byArchivePath = await backend.internalApi.fetchConversionJobLogs(
                companyId,
                50,
                undefined,
                archiveFilePath,
                0,
                "CREATED",
                "DESC",
                auth
            );

            const entries = this.mergeUniqueLogs(byFileName.entries || [], byArchivePath.entries || []);
            const matchingLogs = this.findMatchingConversionLogs(entries, archiveFilePath, fileEntry.name);
            const selectedLog = matchingLogs.length > 0 ? matchingLogs[0] : null;
            this.setState({
                conversionJobLogs: matchingLogs,
                selectedConversionJobLog: selectedLog,
                conversionJobLogError: selectedLog ? null : "No conversion job log found for this file.",
            });
        } catch (error) {
            this.setState({
                conversionJobLogError: "Failed to load conversion job log.",
                conversionJobLogs: [],
            });
        } finally {
            this.setState({conversionJobLogLoading: false});
        }
    }

    createTableColumns() {

        return [{
            id: 'select',
            Header: 'Select',
            width: 70,
            accessor: (d: any) => {
                if (this.context.ftpPath != "/" && !d.isDirectory) {
                    return <Checkbox
                        checked={this.state.selectedFiles.some(name => name === d.name)}
                        onChange={() => this.switchSelectionStateOfItem(d.name)}
                    />
                } else {
                    return null
                }
            },
            sortField: 'NONE'
        }, {
            id: 'dir',
            Header: 'Dir',
            width: 40,
            accessor: (d: any) => {
                if (d.isDirectory) {
                    return <Icon name='folder'/>
                } else {
                    return <Icon name='file outline'/>
                }
            }, // when changing the Folder-Icon, make sure you also change it in the ReactTable in the click desicion
            sortField: 'DIRECTORY'

        }, {
            id: 'name',
            Header: 'Name',
            width: 350,
            accessor: (d: any) => d.name,
            sortField: 'NAME'

        }, {
            id: 'size',
            Header: 'Size',
            width: 100,
            accessor: (d: any) => {
                if (d.isDirectory) {
                    return <p/>
                } else {
                    return this.getReadableFileSizeString(d.size)
                }
            },
            sortField: 'SIZE'

        }, {
            id: 'created',
            Header: 'Created',
            width: 150,
            accessor: (d: any) => d.created,
            Cell: (d: any) => {
                return <span>{formatDate(d.value)}</span>
            },
            sortField: 'CREATED'

        }, {
            id: 'updated',
            Header: 'Updated',
            width: 150,
            accessor: (d: any) => d.updated,
            Cell: (d: any) => {
                return <span>{formatDate(d.value)}</span>
            },
            sortField: 'MODIFIED'

        }, {
            id: 'buttons',
            Header: 'Options',
            width: 290,
            accessor: (d: any) => <ButtonGroup>
                <Popup content={"move"} trigger={
                    <Button icon
                            disabled={this.context.ftpPath == "/"}
                            onClick={() => this.moveFile(d)}>
                        <Icon name='move'/>
                    </Button>
                }/>
                <Popup content={"delete"} trigger={
                    <Button icon
                            disabled={this.context.ftpPath == "/"}
                            onClick={() => this.deleteFile(d)}>
                        <Icon name='trash'/>
                    </Button>
                }/>
                <Popup content={"download"} trigger={
                    <Button
                        icon
                        disabled={this.context.ftpPath == "/"}
                        onClick={() => {
                            this.downloadFile(d, d.isDirectory).then(r => {
                            })
                        }}
                        loading={this.state.isLoading}
                    >
                        <Icon name='download'/>
                    </Button>
                }/>
                <Popup content={"open in new tab"} trigger={
                    <Button
                        icon
                        disabled={this.context.ftpPath == "/" || d.isDirectory}
                        onClick={() => this.openFileInNewTab(d)}
                    >
                        <Icon name='linkify'/>
                    </Button>
                }/>
                <Popup content={"edit"} trigger={
                    <Button
                        icon
                        disabled={d.isDirectory}
                        onClick={() => this.setState({renameFile: d, showRenameModal: true})}
                    >
                        <Icon name='pencil'/>
                    </Button>
                }/>
                <Popup content={"open in importSim"} trigger={
                    <Button
                        icon
                        style={{height: 36}}
                        disabled={d.isDirectory || this.context.ftpPath == "/"}
                        onClick={() => this.openInImportSim(d.name)}>
                        <FaFileImport/>
                    </Button>
                }/>
                <Popup content={"show conversion job log"} trigger={
                    <Button
                        icon
                        style={{height: 36}}
                        disabled={d.isDirectory || this.context.ftpPath == "/"}
                        onClick={() => this.openConversionJobLog(d)}>
                        <Icon name='info circle'/>
                    </Button>
                }/>
            </ButtonGroup>,
            sortField: 'NONE'
        }]

    }

    renderTable(files) {
        const columns = this.createTableColumns()

        console.log("PAGE: ", this.state.page)
        return <ReactTable
            data={files}
            manual
            page={this.state.page}
            pages={Math.ceil(this.state.response.totalFiles / this.state.take)}
            pageSizeOptions={[25, 50, 100, 250, 500, 1000]}
            columns={columns}
            onSortedChange={(newSorted, column, shiftKey) => {
                this.changeSort(column.sortField)
            }}
            pageSize={this.state.take}
            defaultPageSize={this.state.take}
            className="-striped -highlight"
            loading={this.state.isLoading}
            getTdProps={(state, rowInfo, column, instance) => {
                return {
                    onClick: () => {
                        if (rowInfo) {
                            if (column.id != 'buttons' && column.id != 'select') {
                                if (rowInfo.row.dir.props.name == 'folder') {
                                    console.log("Opening Dir: ", rowInfo.row.name)
                                    this.goDownADir(rowInfo.row.name)
                                } else {
                                    console.log("Opening File: ", rowInfo.row.name)
                                    this.openFile(rowInfo.row.name)
                                }
                            }
                        }
                    }
                };
            }}
            style={{cursor: "pointer"}}
            onPageChange={(pageIndex) => this.changePage(pageIndex)}
            onPageSizeChange={(pageSize, pageIndex) => this.changePageSize(pageSize)}
        />
    }

    async downloadFile(fileEntry: FileSystemEntry, deleteFileAfterwards: boolean = false) {

        this.setState({
            fileEntryToDownload: fileEntry,
            openFileDownloadModal: true,
        })

    }

    deleteFile(file: FileSystemEntry) {
        this.setState({fileToDelete: file, openFileDeleteView: true})
    }

    sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }

    async openInImportSim(file: string | null = null) {

        let files: any[] = []
        if (file != null) {
            files.push({
                file: await this.readFile(file),
                fileName: file,
                state: "NOT_PROCESSED"
            } as FileWithState)

        } else {

            for (const f of this.state.selectedFiles) {
                files.push({
                    file: await this.readFile(f),
                    fileName: f,
                    state: "NOT_PROCESSED"
                } as FileWithState)
            }
        }
        uploadedFiles.value = files

        // setting tab to importSim
        this.context.setSingleTabSession("converterTab", 1) // 1 = importSim
        this.context.setSingleTabSession("importSimTab", 1) // 1 = file

        // moving to convPage
        let url = "/" + this.context.companyId + "/convPage"
        this.props.history.push(url)

    }

    moveFile(file: FileSystemEntry) {
        this.setState({fileToMove: file, openFileMoveView: true})

    }

    goDownADir(newDir: string) {
        console.log("NewDir: ", newDir)

        console.log("state.path: ", this.context.ftpPath)
        this.openDir(this.context.ftpPath + "/" + newDir)
    }

    goUpADir() {

        let path = this.context.ftpPath
        if (path != "/") {
            let newPath = path.substring(0, path.lastIndexOf("/"))
            this.openDir(newPath).then(_ => {
            })
        } else {
            console.log("cannot go up further")
        }
    }

    getReadableFileSizeString(fileSizeInBytes) {
        let i = -1;
        let byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
        do {
            fileSizeInBytes = fileSizeInBytes / 1024;
            i++;
        } while (fileSizeInBytes > 1024);

        return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    }

    async openFile(fileName: string) {
        console.log("openFile: ", fileName)

        let response = await this.getFile(fileName)

        this.setState({openFile: true, fileToOpenBuffer: await response.arrayBuffer(), fileToOpenName: fileName})
    }

    async readFile(fileName: string) {
        let response = await this.getFile(fileName)
        return new Blob([await response.arrayBuffer()], {type: 'application/pdf'})
    }

    async getFile(fileName: string) {
        console.log("getFile: ", fileName)

        let path = this.context.ftpPath
        let request = {} as OpenFileRequest
        request.fileName = fileName

        let auth = backend.withTokenAuthHeader(authentication.token)

        let pathParameter = this.buildPathForApi(path)
        return await this.openFileFetchCall(pathParameter, request, auth)
    }

    async openFileFetchCall(pathParameter: string, request: OpenFileRequest, options?: any) {
        console.log("/ftp/openFile Request: ", request)

        return await fetch('/ftp/openFile' + pathParameter, {
            method: 'POST',
            headers: {
                "Authorization": options.headers.Authorization,
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify(request)
        })
    }

    private renderModals() {
        return <>
            <IfBox shouldShow={this.state.openFile}>
                <FtpExplorerFileModal
                    fileBuffer={this.state.fileToOpenBuffer}
                    isOpen={this.state.openFile}
                    onClose={() => {
                        this.setState({fileToOpenBuffer: null, openFile: false})
                    }}
                    fileName={this.state.fileToOpenName}
                />
            </IfBox>
            <IfBox shouldShow={this.state.openFileDeleteView}>
                <FtpExplorerFileDeleteModal
                    file={this.state.fileToDelete}
                    isOpen={this.state.openFileDeleteView}
                    path={this.context.ftpPath}
                    onClose={(success) => {
                        if (success == true) {
                            notify.show('File has been deleted', 'success', 3000, '#28f751');
                        }
                        this.setState({fileToDelete: null, openFileDeleteView: false})
                        this.openDir(this.context.ftpPath)
                    }}
                />
            </IfBox>
            <IfBox shouldShow={this.state.openMultiFileDeleteView}>
                <FtpExplorerMultiFileDeleteModal
                    files={this.state.selectedFiles}
                    isOpen={this.state.openMultiFileDeleteView}
                    path={this.context.ftpPath}
                    onClose={(success) => {
                        if (success == true) {
                            notify.show('File has been deleted', 'success', 3000, '#28f751');
                        }
                        this.setState({selectedFiles: [], openMultiFileDeleteView: false})
                        this.openDir(this.context.ftpPath)
                    }}
                />
            </IfBox>
            <IfBox shouldShow={this.state.openFileMoveView}>
                <FtpExplorerFileMoveModal
                    file={this.state.fileToMove}
                    isOpen={this.state.openFileMoveView}
                    sourcePath={this.context.ftpPath}
                    onClose={
                        (success) => {
                            if (success == true) {
                                notify.show('File has been moved', 'success', 3000, '#28f751');
                            }
                            this.setState({fileToMove: null, openFileMoveView: false})
                            this.openDir(this.context.ftpPath)
                        }
                    }
                    sortBy={this.state.sortBy}
                    sortDirection={this.state.sortDirection}
                />
            </IfBox>
            <IfBox shouldShow={this.state.showAddFileModal}>
                <FtpExplorerAddFileModal
                    isOpen={this.state.showAddFileModal}
                    onClose={(success) => {
                        if (success == true) {
                            notify.show('File has been added', 'success', 3000, '#28f751');
                        }
                        this.setState({showAddFileModal: false})
                        this.openDir(this.context.ftpPath).then(_ => {
                        })
                    }}
                    path={this.context.ftpPath}
                    fileName={""}
                    contentBase64={null}
                    content=""
                    encoding="UTF-8" // maybe make it changable for the user???
                />
            </IfBox>
            <IfBox shouldShow={this.state.showUploadFileModal}>
                <FtpExplorerUploadFileModal
                    isOpen={this.state.showUploadFileModal}
                    onClose={(success) => {
                        if (success == true) {
                            notify.show('File has been added', 'success', 3000, '#28f751');
                        }
                        this.setState({showUploadFileModal: false})
                        this.openDir(this.context.ftpPath).then(_ => {
                        })
                    }}
                    path={this.context.ftpPath}/>
            </IfBox>
            <IfBox shouldShow={this.state.openFileDownloadModal}>
                <FtpExplorerSignedDownloadFileModal
                    isOpen={this.state.openFileDownloadModal}
                    onClose={() => {
                        this.setState({openFileDownloadModal: false})
                        if (this.state.deleteFileAfterwards) {
                            this.deleteFile(this.state.fileEntryToDownload)
                        }
                        this.openDir(this.context.ftpPath)
                    }}
                    path={this.context.ftpPath}
                    fileEntry={this.state.fileEntryToDownload}
                />
            </IfBox>
            <IfBox shouldShow={this.state.showMoveMultipleFilesModal}>
                <FtpExplorerMultipleFileMoveModal
                    isOpen={this.state.showMoveMultipleFilesModal}
                    sourcePath={this.context.ftpPath}
                    onClose={
                        (success) => {
                            if (success == true) {
                                notify.show('Files has been moved', 'success', 3000, '#28f751');
                            }
                            this.setState({selectedFiles: [], showMoveMultipleFilesModal: false})
                            this.openDir(this.context.ftpPath)
                        }
                    }
                    sortBy={this.state.sortBy}
                    sortDirection={this.state.sortDirection}
                    files={this.state.selectedFiles}/>
            </IfBox>
            <IfBox shouldShow={this.state.showRenameModal}>
                <FtpExplorerRenameFileModal
                    isOpen={this.state.showRenameModal}
                    onClose={
                        (change) => {
                            if (change == true) {
                                notify.show('File has renamed', 'success', 3000, '#28f751');
                            }
                            this.setState({showRenameModal: false})
                            this.openDir(this.context.ftpPath).then(_ => {
                            })
                        }
                    }
                    path={this.context.ftpPath}
                    file={this.state.renameFile}/>
            </IfBox>
            <IfBox shouldShow={this.state.openFilesDownloadModal}>
                <FtpExplorerMultiFileDownloadModal
                    isOpen={this.state.openFilesDownloadModal}
                    onClose={(success) => {
                        this.setState({openFilesDownloadModal: false})
                        if (success) {
                            notify.show('Files has been downloaded', 'success', 3000, '#28f751');
                            this.openDir(this.context.ftpPath).then(_ => {
                            })
                        }
                    }}
                    files={this.state.selectedFiles}
                    path={this.context.ftpPath}
                />
            </IfBox>
            <FtpExplorerConversionJobLogModal
                isOpen={this.state.openConversionJobLogModal}
                onClose={() => this.setState({openConversionJobLogModal: false})}
                isLoading={this.state.conversionJobLogLoading}
                errorMessage={this.state.conversionJobLogError}
                logs={this.state.conversionJobLogs}
                log={this.state.selectedConversionJobLog}
                onSelectLog={(log) => this.setState({selectedConversionJobLog: log})}
                requestedFilePath={this.state.conversionJobLogFilePath}
            />
        </>
    }
}
